import { ListItem } from "arkh";
import { ActivityIndicator, ScrollView } from "react-native";
import React from "react";
import { useOrgHomeDetailLayout } from "../useOrgHomeDetailContainerStyle";
import { listGutterStyle } from "../guterStyle";

export function LoadingList(props: { header: React.ReactElement }) {
  const detailLayout = useOrgHomeDetailLayout();
  return (
    <ScrollView
      style={[
        { flex: 1, marginBottom: detailLayout.keyboardBottomInset },
        listGutterStyle,
      ]}
      contentContainerStyle={detailLayout.contentContainerStyle}
    >
      {props.header}
      <ListItem isLast>
        <ActivityIndicator />
      </ListItem>
    </ScrollView>
  );
}
